import React from 'react';
import { ArrowRight, ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';

import bakpiaPremium from '../assets/bakpia_premium.png';
import overlay from '../assets/coklat.png';
import halalHijau from '../assets/halal_hijau.png';

const HeroSection = () => {
  const { language, t } = useLanguage();
  const navigate = useNavigate();

  const scrollToProducts = () => {
    const section = document.getElementById('products');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-gradient-to-br from-[#FED09D] via-[#FED09D] to-[#FED09D]/80">
      {/*  with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={bakpiaPremium}
          alt=""
          width="500"
          height="300"
          className="w-full h-full object-cover object-[80%_70%] opacity-40"
          aria-hidden="true"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#FED09D]/95 via-[#FED09D]/90 to-transparent"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-64 h-64 bg-[#B22222]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-80 h-80 bg-[#B22222]/5 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="space-y-8 animate-in fade-in slide-in-from-left duration-700">
            <div className="inline-block">
              {/* <span className="bg-[#B22222] text-white px-4 py-2 rounded-full text-sm font-medium shadow-lg">
                ✨ {language === 'id' ? 'Resep Turun Temurun' : 'Traditional Family Recipe'}
              </span> */}
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#3E2723] leading-tight">
              {t.hero.headline}
            </h1>

            <p className="text-lg sm:text-xl text-[#3E2723]/80 leading-relaxed max-w-xl">
              {t.hero.subheadline}
            </p>

            <div className="flex pt-4">
              <Button
                onClick={scrollToProducts}
                size="lg"
                className="bg-[#B22222] hover:bg-[#8B0000] text-white px-10 py-7 text-lg rounded-full transition-all duration-300 hover:shadow-xl hover:scale-105 group w-full sm:w-auto min-w-[240px]"
              >
                {language === 'id' ? 'Lihat Best Seller' : 'View Best Sellers'}
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
            </div>

            {/* Trust Badges */}
            <div className="grid grid-cols-3 sm:flex sm:flex-wrap sm:justify-start gap-2 sm:gap-6 pt-6 w-full">
              <div className="flex flex-col sm:flex-row items-center justify-start gap-1.5 sm:gap-2 text-center sm:text-left">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full flex items-center justify-center shadow-md border border-gray-100 overflow-hidden p-1 shrink-0">
                  <img src={halalHijau} alt="Halal Indonesia" className="w-full h-full object-contain" />
                </div>
                <span className="text-[11px] sm:text-sm font-medium text-[#3E2723] leading-tight">
                  {language === 'id' ? '100% Halal' : '100% Halal'}
                </span>
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-start gap-1.5 sm:gap-2 text-center sm:text-left">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full flex items-center justify-center shadow-md shrink-0">
                  <span className="text-xl sm:text-2xl" role="img" aria-label="natural">🌿</span>
                </div>
                <span className="text-[11px] sm:text-sm font-medium text-[#3E2723] leading-tight">
                  {language === 'id' ? 'Tanpa Pengawet' : 'No Preservatives'}
                </span>
              </div>
              <div className="flex flex-col sm:flex-row items-center justify-start gap-1.5 sm:gap-2 text-center sm:text-left">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white rounded-full flex items-center justify-center shadow-md shrink-0">
                  <span className="text-xl sm:text-2xl" role="img" aria-label="experience">⭐</span>
                </div>
                <span className="text-[11px] sm:text-sm font-medium text-[#3E2723] leading-tight">
                  {language === 'id' ? '20+ Tahun' : '20+ Years'}
                </span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative animate-in fade-in slide-in-from-right duration-700 delay-200">
            <div className="relative">
              <div className="absolute -inset-4 bg-[#B22222]/20 rounded-3xl blur-2xl"></div>
              <img
                src={bakpiaPremium}
                alt="Authentic Jogja Bakpia"
                width="940"
                height="650"
                fetchpriority="high"
                className="relative rounded-3xl shadow-2xl w-full h-[500px] sm:h-[700px] lg:h-[740px] object-cover object-[center_60%]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
